import React, { useContext } from 'react'

import {
    FaAngleDown,
    FaAngleUp,
    FaArrowAltCircleUp,
    FaCompressArrowsAlt,
    FaExpandArrowsAlt,
    FaRegArrowAltCircleUp,
    FaSlidersH,
    FaThList,
} from 'react-icons/fa'

import PanelHeader from '../../../elem/panel/PanelHeader'
import { IconTooltip as Tooltip } from '../../../elem/Tooltip'
import ExpandButton from '../../../elem/list/ExpandButton'
import { PanelStyleContext } from '../../../elem/panel/PanelStyleContext'
import CollapseButton from '../../../elem/list/CollapseButton'

export default ({
    name,
    filterExpanded,
    toggleFilter,
    togglePromotedRecords,
    promotedRecords,
    setCollapsed,
    isCollapsed,
}) => {
    const { isExpanded, setIsExpanded } = useContext(PanelStyleContext)

    return (
        <PanelHeader extraClass={'samplePanelHeader'}>
            <div className="panelHeaderText">Sample Result Explorer</div>
            <div className="panelHeaderControls">
                <div className="panelHeaderIconWrapper">
                    {!filterExpanded && (
                        <div
                            className="panelHeaderIconDiv"
                            data-tooltip-content={`${
                                promotedRecords
                                    ? `Do not promote Selected Records`
                                    : `Promote Selected Records`
                            }`}
                            data-tooltip-id={`sample-promoted-records-toggle-${promotedRecords}`}
                            onClick={() =>
                                togglePromotedRecords(
                                    !promotedRecords,
                                    'sample'
                                )
                            }
                        >
                            {promotedRecords ? (
                                <FaArrowAltCircleUp />
                            ) : (
                                <FaRegArrowAltCircleUp />
                            )}
                            <Tooltip
                                id={`sample-promoted-records-toggle-${promotedRecords}`}
                            />
                        </div>
                    )}
                    <div
                        className="panelHeaderIconDiv"
                        data-tooltip-content={`${
                            filterExpanded
                                ? 'View Sample Result List'
                                : 'View Sample Result Filter'
                        }`}
                        data-tooltip-id={`sample-view-toggle-${filterExpanded}`}
                        onClick={() => toggleFilter(!filterExpanded)}
                    >
                        {filterExpanded ? <FaThList /> : <FaSlidersH />}
                        <Tooltip id={`sample-view-toggle-${filterExpanded}`} />
                    </div>
                    {isExpanded ? null : (
                        <CollapseButton
                            name={`sample-explorer`}
                            isCollapsed={isCollapsed}
                            setCollapsed={setCollapsed}
                        />
                    )}
                    <ExpandButton
                        name={name}
                        isExpanded={isExpanded}
                        setIsExpanded={setIsExpanded}
                    />
                </div>
            </div>
        </PanelHeader>
    )
}
